var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgM(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 36,
    viewBox: "0 0 39 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.6809V10.1226L20.6143 21.7306V35.289L0 23.6809Z",
    fill: "url(#paint0_linear_2934_6259)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 25.1197V11.6079L20.6143 21.7302V35.2884L39 25.1197Z",
    fill: "url(#paint1_linear_2934_6259)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.1222L18.3857 0L39 11.6081L20.5679 21.7303L0 10.1222Z",
    fill: "url(#paint2_linear_2934_6259)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93579 18.248L8.77509 18.6659V19.2696L10.0751 18.7588V21.6376L10.4929 21.9162V19.0374L11.7929 21.2197V20.6161L10.6322 18.7588L9.93579 18.248Z",
    fill: "#2FAB46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3787 28.4167L23.3072 29.1131L23.8179 28.8346L22.7501 28.0916L25.0715 26.8844V26.4665L22.7501 27.6737L23.8644 25.77L23.3536 26.0486L22.3787 27.6737V28.4167Z",
    fill: "#2FAB46"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8856 19.1296L37.0035 18.4331L36.5392 18.6653L37.5142 19.4546L35.4249 20.5226V20.9404L37.5142 19.8725L36.5392 21.7298L37.0035 21.4976L37.8392 19.9189L37.8856 19.1296Z",
    fill: "#2FAB46"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70723 25.4915L7.38226 25.3057V23.1698L6.77869 23.0305V22.752L7.70723 22.9377L7.75368 22.9841V25.4915H7.70723Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70354 26.6521L9.37853 26.4664V24.3305L8.72852 24.1912V23.9126L9.65709 24.0983L9.70354 24.1448V26.6521Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1642 27.023C12.2106 27.2551 12.1177 27.5337 11.9785 27.7194C11.8392 27.8123 11.6535 27.8123 11.3749 27.6266C11.1428 27.4873 10.9106 27.2551 10.7714 27.023C10.6321 26.7444 10.5856 26.4193 10.5856 26.0943V25.6764C10.5856 25.5371 10.5856 25.4443 10.6321 25.305C10.6785 25.1657 10.7249 25.0728 10.8178 24.9799C10.9571 24.8871 11.1428 24.8871 11.4213 25.0728C11.6535 25.2121 11.8856 25.3978 12.0249 25.6764C12.1642 25.955 12.2106 26.28 12.2106 26.6051V27.023H12.1642ZM11.8856 26.4193C11.8856 26.1872 11.8392 26.0015 11.7928 25.7693C11.6999 25.5836 11.607 25.4443 11.4213 25.3514C11.282 25.2585 11.1428 25.2585 11.0499 25.3514C10.9571 25.4907 10.9106 25.6764 10.957 25.8622V26.3729C10.957 26.6051 11.0035 26.8372 11.0499 27.023C11.1428 27.2087 11.2356 27.348 11.4213 27.4409C11.5606 27.5337 11.6999 27.5337 11.7928 27.4409C11.8856 27.3016 11.932 27.1158 11.932 26.9301L11.8856 26.4193Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5322 24.888L27.8108 24.7487C27.9965 24.6558 28.1358 24.563 28.2286 24.3772C28.3215 24.2379 28.4143 24.0522 28.4143 23.9129C28.4143 23.5414 28.2286 23.495 27.8572 23.6807C27.7179 23.7736 27.5322 23.8665 27.4393 24.0522C27.3465 24.1915 27.3 24.3308 27.3 24.5165L26.9286 24.7487C26.9286 24.4701 27.0215 24.2379 27.2072 24.0058C27.3929 23.7736 27.625 23.5414 27.9036 23.4021C27.9965 23.3093 28.1358 23.2629 28.2286 23.2629C28.3679 23.2164 28.4608 23.2164 28.6 23.2629C28.7858 23.3093 28.8322 23.495 28.8322 23.7736C28.8322 23.9129 28.7858 24.0986 28.6929 24.2379C28.6 24.4237 28.5072 24.563 28.3215 24.7023C28.3679 24.7023 28.4608 24.6558 28.5072 24.7023C28.5536 24.7023 28.6465 24.7487 28.6929 24.7487C28.7393 24.7951 28.7858 24.8415 28.7858 24.888C28.8322 24.9344 28.8322 25.0273 28.8322 25.0737C28.8322 25.3523 28.7393 25.6309 28.5536 25.8631C28.3679 26.1417 28.1358 26.3274 27.8572 26.4667C27.6715 26.606 27.3929 26.6524 27.1608 26.606C26.975 26.5595 26.8822 26.4202 26.8822 26.1417L27.3 25.9095C27.3 26.0488 27.3465 26.1881 27.4393 26.1881C27.5786 26.2345 27.6715 26.1881 27.8108 26.1417C27.9965 26.0488 28.1358 25.9095 28.2286 25.7702C28.3215 25.6309 28.3679 25.4452 28.3679 25.2594C28.3679 25.0737 28.3215 24.9808 28.1822 24.9344C27.9965 24.9344 27.8572 24.9344 27.7179 25.0273L27.4393 25.1666V24.888H27.5322Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8464 21.9158C33.8464 22.2873 33.8 22.7052 33.6143 23.0302C33.4286 23.3551 33.1964 23.5873 32.8714 23.7266C32.5 23.9123 32.3143 23.9123 32.1286 23.8194C32.0357 23.7266 31.9429 23.5873 31.8964 23.448C31.85 23.3087 31.85 23.1231 31.85 22.9838V22.473C31.85 22.1016 31.8964 21.6837 32.0821 21.3586C32.2678 21.0336 32.5 20.8015 32.825 20.6622C33.15 20.4764 33.3821 20.4764 33.5679 20.5693C33.7071 20.7086 33.8 20.9872 33.8 21.4051V21.9158H33.8464ZM33.4286 21.5908C33.475 21.3586 33.4286 21.1265 33.2893 20.9408C33.1964 20.8479 33.0571 20.8479 32.825 20.9408C32.6393 21.0336 32.4536 21.2194 32.3607 21.4051C32.2679 21.6372 32.2214 21.9158 32.2214 22.148V22.7516C32.175 22.9838 32.2679 23.2159 32.3607 23.4015C32.4536 23.4944 32.5929 23.4944 32.825 23.4015C33.0107 23.3087 33.15 23.1231 33.2428 22.9373C33.3357 22.7052 33.3822 22.4266 33.3822 22.1944V21.5908H33.4286Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1071 12.8153L27.1143 10.4937L7.33569 9.98291L21.3571 18.48L21.5893 18.3407L31.1071 12.8153Z",
    fill: "url(#paint3_linear_2934_6259)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4502 17.9692L30.5038 12.7224L17.5037 4.87531C17.3645 4.78245 17.2252 4.78245 17.0859 4.87531L8.3573 9.93643L21.4502 17.9692Z",
    fill: "#2FAB46"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4502 17.8764L30.5038 12.6296L17.5037 4.78254C17.3645 4.68967 17.2252 4.68967 17.0859 4.78254L8.3573 9.84366L21.4502 17.8764Z",
    fill: "#EFF7FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4502 17.6909L30.4573 12.3976L17.5038 4.59699C17.3645 4.50413 17.2252 4.50413 17.0859 4.59699L8.3573 9.65811L21.4502 17.6909Z",
    fill: "#2FAB46"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4502 17.5508L30.5038 12.3039L17.5037 4.45686C17.3645 4.36399 17.2252 4.36399 17.0859 4.45686L8.3573 9.51798L21.4502 17.5508Z",
    fill: "#EFF7FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4502 17.3662L30.5038 12.1193L17.5037 4.27229C17.3645 4.17942 17.2252 4.17942 17.0859 4.27229L8.3573 9.33341L21.4502 17.3662Z",
    fill: "#2FAB46"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4502 17.2724L30.5038 12.0256L17.5037 4.17854C17.3645 4.08567 17.2252 4.08567 17.0859 4.17854L8.3573 9.23966L21.4502 17.2724Z",
    fill: "#EFF7FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4502 17.0405L30.5038 11.7937L17.5037 3.9466C17.3645 3.85374 17.2252 3.85374 17.0859 3.9466L8.3573 9.00772L21.4502 17.0405Z",
    fill: "#2FAB46"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4502 16.9477L30.5038 11.7009L17.5037 3.85383C17.3645 3.76096 17.2252 3.76096 17.0859 3.85383L8.3573 8.91495L21.4502 16.9477Z",
    fill: "#EFF7FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4502 16.6694L30.5038 11.4226L17.5037 3.57551C17.3645 3.48264 17.2252 3.48264 17.0859 3.57551L8.3573 8.63663L21.4502 16.6694Z",
    fill: "#2FAB46"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4502 16.5762L30.5038 11.3293L17.5037 3.48225C17.3645 3.38938 17.2252 3.38938 17.0859 3.48225L8.3573 8.54337L21.4502 16.5762Z",
    fill: "#EFF7FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1074 10.261L17.3181 1.90314C17.1788 1.81028 16.9931 1.81028 16.8538 1.90314L7.52163 7.33572C7.1502 7.52145 6.96448 7.89291 6.96448 8.3108V9.61091C6.96448 9.79664 7.10375 9.98236 7.24304 10.0288L21.2181 18.4795L21.0788 16.6686L21.4966 15.8328L31.1074 10.261ZM9.70378 10.911C9.37878 10.7253 9.10018 10.2145 9.10018 9.84307C9.10018 9.47161 9.37878 9.28588 9.70378 9.47161C10.0288 9.65734 10.3073 10.1681 10.3073 10.5396C10.3073 10.9574 10.0288 11.0967 9.70378 10.911Z",
    fill: "url(#paint4_linear_2934_6259)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4965 15.8328L31.1072 10.261L17.3179 1.90314C17.1786 1.81028 16.9929 1.81028 16.8536 1.90314L7.52148 7.33573L21.4965 15.8328Z",
    fill: "url(#paint5_linear_2934_6259)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5892 18.3404C21.5428 18.3404 21.4963 18.3868 21.4499 18.3868C21.3106 18.3868 21.1713 18.294 21.1713 18.1082V16.8081C21.1713 16.4367 21.3571 16.1581 21.6821 15.9724L31.1071 10.4933V10.3076L21.5892 15.7866C21.2178 15.9724 21.032 16.3438 21.032 16.7617V18.0618C21.032 18.4333 21.4035 18.619 21.7285 18.4333L31.1535 12.9543V12.7221L21.5892 18.3404Z",
    fill: "#494855"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7036 9.28647C9.28574 9.05431 8.91431 9.24004 8.91431 9.70436C8.91431 10.2151 9.28574 10.8187 9.7036 11.0509C10.1215 11.2831 10.4929 11.0973 10.4929 10.633C10.4929 10.1687 10.1215 9.56506 9.7036 9.28647Z",
    fill: "#2FAB46"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7145 15.1831L11.0037 11.8864V10.2612L16.7145 13.5579V15.1831Z",
    fill: "url(#paint6_linear_2934_6259)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5501 21.9166C31.1072 21.5916 31.4786 21.9166 31.4786 22.7524C31.4786 23.4489 31.2929 24.0525 31.0144 24.5168C30.7822 24.8883 30.5036 25.2133 30.2251 25.3991C30.1322 25.4919 30.0393 25.5384 29.9465 25.5848C29.9001 25.5848 29.9001 25.6312 29.8536 25.6312V25.2598C29.8536 25.2598 29.9001 25.2598 29.9465 25.2133C29.9929 25.1669 30.0858 25.1205 30.1786 25.074C30.4108 24.9347 30.5965 24.7026 30.7822 24.424C30.9679 24.1454 31.1072 23.7739 31.1536 23.356C31.0143 23.6811 30.7822 23.9132 30.5036 24.099C29.9929 24.3775 29.6679 24.1454 29.6679 23.5882C29.5751 22.9846 29.9929 22.2417 30.5501 21.9166ZM31.0608 23.0774C31.1072 23.031 31.1072 22.9846 31.1072 22.8917C31.1072 22.3345 30.9215 22.0095 30.5501 22.2417C30.2251 22.4274 29.9929 22.8917 29.9929 23.356C29.9929 23.7739 30.2251 23.9132 30.5501 23.7275C30.7822 23.5882 30.9679 23.356 31.0608 23.0774Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2934_6259",
    x1: 15.0215,
    y1: 20.2033,
    x2: -0.756407,
    y2: 28.5868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2934_6259",
    x1: 37.0723,
    y1: 25.0222,
    x2: 14.0557,
    y2: 20.0384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBCBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2934_6259",
    x1: 32.4141,
    y1: 17.3317,
    x2: -8.44435,
    y2: -3.09585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#EAE9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2934_6259",
    x1: 19.2646,
    y1: 11.3637,
    x2: 27.1485,
    y2: 6.5224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2CAB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E2D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2934_6259",
    x1: 15.5751,
    y1: 15.6982,
    x2: 17.2858,
    y2: 12.4682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEF3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2396,
    stopColor: "#A9D1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2934_6259",
    x1: 19.3287,
    y1: 15.8499,
    x2: 19.3287,
    y2: -21.2974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F7FFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0F8E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2934_6259",
    x1: 14.3601,
    y1: 12.331,
    x2: 10.9065,
    y2: 15.0535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#E4F2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCFFD5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM);
export default __webpack_public_path__ + "static/media/m.7b6b1bd294fa3d906d71c1c0ea8fbc7d.svg";
export { ForwardRef as ReactComponent };